import React from 'react';
import { OpForm } from 'components/customAntd/DLS/OpForm/OpForm';
import { StopOutlined, EyeOutlined } from "@ant-design/icons";
import { DATE_FORMAT } from 'constants/dates';
import { useTranslation } from 'react-i18next';

const RedFlagForm: React.FC = () => {
    const { t } = useTranslation();

    return (
        <>
            <OpForm.Select
                label={t('redFlag.form.level')} name="level" rules={[{ required: true, message: t('redFlag.form.levelRequired') }]}
                placeholder="Select type"
                options={[
                    { label: <span><StopOutlined style={{ color: 'rgba(242,103,87,1.0)' }} /> {t('redFlag.form.blocklist')} </span>, value: 1 },
                    { label: <span><EyeOutlined style={{ color: '#FFD54F' }} /> {t('redFlag.form.watchlist')} </span>, value: 2 }
                ]}
            />
            <OpForm.Input label={t('redFlag.form.effectiveDate')} name="effectiveDate" disabled={true} />
            <OpForm.DatePicker format={DATE_FORMAT} label={t('redFlag.form.expireDate')} name="expireDate" />
        </>
    );
};

export default RedFlagForm;
